import { useEffect } from "react";
import { ViewType } from "@common/types/views/views";
import { useScope } from "@state/scopeContext.lib";
import { prefetchViews } from "@api/view.api";

export function usePrefetchTransactionViews() {
    const { workspaceId } = useScope();

    useEffect(() => {
        if (workspaceId) {
            prefetchViews({
                scope: { workspaceId },
                type: ViewType.TRANSACTION,
            });
        }
    }, [workspaceId]);
}
